<template>
  <BaseSelectField
    v-bind="$props"
    :model-value="value || placeholderValue"
    :placeholder="placeholderProp"
    :placeholder-value="placeholderValue"
    @change="$emit('change', $event)"
    @update:modelValue="$emit('input', $event)"
    @selectClick="$emit('selectClick')"
  >
    <option
      v-if="placeholder && placeholderValue"
      :value="placeholderValue"
      selected
    >
      {{ placeholder }}
    </option>
    <option
      v-for="({ label, isBlocked }, key) in timeSlots"
      :value="key"
      :key="key"
      :disabled="isBlocked"
    >
      {{ label }}
    </option>
  </BaseSelectField>
</template>

<script>
import { getTimeSlots, HOURS_MAP_24 } from '@/services/hours-map';

import htmlProps from '../htmlProps.js';
import BaseSelectField from './BaseSelectField.vue';
import commonProps from './common-props-mixin';
import validation from './validation-mixin';

export default {
  name: 'TimeField',
  emits: ['change', 'input', 'selectClick'],
  mixins: [validation, commonProps, htmlProps],
  components: { BaseSelectField },
  props: {
    value: {
      type: Number,
      default: null,
    },
    minValue: {
      type: Number,
      default: -Infinity,
    },
    maxValue: {
      type: Number,
      default: Infinity,
    },
    placeholderValue: { // It also means the placeholder is selectable
      type: Number,
      default: null,
    },
    timeOptions: {
      type: Object,
      default: null,
    },
    timeFormat: {
      type: Number,
      validator(value) {
        return value === 12 || value === 24;
      },
    },
    blockedTimeSlots: {
      type: Array,
      default: () => [], // Array of tuples with 2 elements
    },
    blockedLabel: {
      type: String,
      default: 'blocked',
    },
    removeLastTimeSlot: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placeholderProp() {
      if (this.placeholderValue) {
        return null;
      }
      return this.placeholder;
    },
    timeSlots() {
      if (this.timeOptions) {
        return this.timeOptions;
      }
      const localizedSlots = getTimeSlots(this.timeFormat);
      const minValue = this.minValue || -Infinity;
      const maxValue = this.maxValue || Infinity;

      const items = Object.keys(HOURS_MAP_24)
        .filter(key => key >= minValue && key <= maxValue);

      if (this.removeLastTimeSlot) {
        items.pop();
      }

      return items.reduce((acc, key) => {
        const isBlocked = this.isTimeSlotBlocked(key);
        return {
          ...acc,
          [key]: {
            label: `${localizedSlots[key]} ${isBlocked ? this.blockedLabel : ''}`,
            isBlocked,
          },
        };
      }, {});
    },
  },

  methods: {
    isTimeSlotBlocked(timeSlot) {
      return this.blockedTimeSlots.some(([timeFrom, timeTo]) => (timeFrom <= timeSlot && timeSlot <= timeTo));
    },
  },
};
</script>
